import { OuterResolvablePromise, PromiseOnSteroids } from "@mp-commons/lib/utils/PromiseOnSteroids.js";
import { MediaEvent, MediaEventType, PlayerEvent, isMediaCompleteEvent, isMediaEvent, isMediaLoadedEvent, isMediaPausedEvent, isMediaProgressEvent, isMediaResumedEvent } from "@mp-commons/modules/events/PlayerEvent.js";
import { ExecutionId } from "@mp-commons/modules/player/MediaResource.js";
import { NielsenCollector, NielsenCollectorFactory } from "@mp-commons/modules/stats/collectors/NielsenCollector.js";
import { CommonEventMapper } from "@mp-commons/modules/stats/mappers/CommonEventMapper.js";
import { VideoInfoRawData } from "@mp-commons/model/video/VideoInfo.js";

export class MegarideNielsenMapper extends CommonEventMapper{
   



    private collectors: {[k: ExecutionId]: OuterResolvablePromise<NielsenCollector>};
    
    constructor(private factory: NielsenCollectorFactory) {
        super();
        this.collectors = {};
       
    }
 
    private getCollector(evt: MediaEvent<VideoInfoRawData>): Promise<NielsenCollector> {
        const id = evt.executionId
        if(!(id in this.collectors)) {
            this.collectors[id] = PromiseOnSteroids.getResolvable();
        }
        if(isMediaLoadedEvent(evt)) {
            this.collectors[id].resolve(this.factory.getCollector(evt));
        }
        return this.collectors[id].promise;
    }



    protected reactToEvents(evt: PlayerEvent): void {
        if(isMediaEvent(evt)) {
            if(evt.eventType == MediaEventType.MEDIA_STARTED) {
                this.getCollector(evt).then(c => c.play());
            }
            else if (isMediaProgressEvent(evt)) {
                this.getCollector(evt).then(c => c.timeupdate(evt.currentTime));
            }
            else if (isMediaCompleteEvent(evt)) {
                this.getCollector(evt).then(c => c.complete());
                
            }
            else if(isMediaPausedEvent(evt)) {
                this.getCollector(evt).then(c => c.pause());
            }
            else if(isMediaResumedEvent(evt)) {
                this.getCollector(evt).then(c => c.play());
            }
            else if (isMediaLoadedEvent(evt)) {
                this.getCollector(evt);
            }
        }
    }



    

}